import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { GraduationCap, Send, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function WeeklyLessonCard() {
    const [next, setNext] = useState(null);
    const [busy, setBusy] = useState(false);
    const load = () => axios.get(`${API}/admin/lessons/next`).then((r) => setNext(r.data)).catch(() => {});
    useEffect(() => { load(); }, []);
    const postNow = async () => {
        if (!window.confirm('Post this lesson to the FREE Telegram group(s) now?')) return;
        setBusy(true);
        try { const { data } = await axios.post(`${API}/admin/lessons/post-now`); toast.success(`Lesson #${data.lesson} posted`); load(); }
        catch (e) { toast.error(e.response?.data?.detail || 'Failed'); }
        setBusy(false);
    };
    if (!next) return null;
    return (
        <div className="rounded-2xl p-5 premium-card" data-testid="weekly-lesson-card">
            <div className="flex items-center justify-between gap-3 flex-wrap mb-3">
                <div className="flex items-center gap-2">
                    <span className="icon-bubble-gold w-9 h-9 rounded-xl flex items-center justify-center"><GraduationCap className="w-4 h-4" style={{ color: '#FFD700' }} /></span>
                    <div>
                        <p className="font-black text-sm" style={{ color: 'var(--text-primary)', fontFamily: "'Outfit', sans-serif" }}>Weekly lesson bot · next up #{next.number} of {next.total}</p>
                        <p className="text-[11px]" style={{ color: 'var(--text-muted)' }}>Auto-posts every Monday 9:00 (Lagos) to the EN + AR free groups with the /learn link.</p>
                    </div>
                </div>
                <Button size="sm" className="btn-primary" onClick={postNow} disabled={busy} data-testid="weekly-lesson-post-btn">{busy ? <Loader2 className="w-4 h-4 animate-spin mr-1" /> : <Send className="w-4 h-4 mr-1" />}Post now</Button>
            </div>
            <p className="text-sm font-bold mb-1" style={{ color: '#FFD700' }} data-testid="weekly-lesson-title">{next.title_en} · <span dir="rtl">{next.title_ar}</span></p>
            <p className="text-xs whitespace-pre-line line-clamp-4" style={{ color: 'var(--text-secondary)' }}>{next.preview_en.replace(/<[^>]+>/g, '')}</p>
            {!!next.last_posts?.length && <p className="text-[11px] mt-2" style={{ color: 'var(--text-muted)' }}>Last posted: lesson #{next.last_posts[0].lesson} · {new Date(next.last_posts[0].posted_at).toLocaleString()} ({next.last_posts[0].trigger})</p>}
        </div>
    );
}
